<template>
  <div>
    <IconDocument />
    <h2 class="weight-medium mt-20">
      Digital Signature
    </h2>
    <p class="body-2 weight-regular mt-10">
      
    Enter a phone number to which we will send you an SMS with the link to digitally sign your application.
  
    </p>

    <div class="input-box-holder mt-20" v-validate="errors">
      <TextField class="input-box"
                 title='Phone Contact'
                 description='Required Format +421 905 123 456'
                 v-model.trim="model.eSignature.phone"
                 v-phone-format
                 :max-length="16"
                 required/>
      <div class="validation-output text-left mt-2">
        <ErrorHandler class="error" id="V331">
          Enter your phone number.
        </ErrorHandler>
        <ErrorHandler class="error" id="V332">
          Enter the phone number in the correct format.
        </ErrorHandler>
      </div>
    </div>

    <div class="width-md mt-20">
      <Button class="btn-primary w-full mb-8" @click="sendSMS" v-scroll-to-error>
        Send SMS
      </Button>
      <UpdateSignatureTypeRedirection :uuid="model.saveResponse.uuid"/>
    </div>

    <Transition name="fade">
      <Loader v-if="!!loaderType" :loader-type="loaderType" @repeat-sms="repeatSms"></Loader>
    </Transition>
  </div>
</template>

<script>
import enums from '@/mixins/enums';
import TextField from '@/components/TextField/TextField.vue';
import Button from '@/components/Button/Button.vue';
import IconDocument from '@/components/Icons/IconDocument.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';
import Loader from '@/components/Loader/Loader.vue';
import UpdateSignatureTypeRedirection
from '@/components/signatures/UpdateSignatureTypeRedirection.vue';

export default {
  name: 'DigitalSignatureSms',
  mixins: [enums],
  props: {
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
  },
  components: {
    UpdateSignatureTypeRedirection,
    TextField,
    IconDocument,
    Button,
    ErrorHandler,
    Loader,
  },
  data: () => ({
    alertVisible: false,
    loaderType: null,
  }),
  methods: {
    processPhone(phone) {
      if (phone) {
        if (/^[0-9]{4}\s[0-9]{3}\s[0-9]{3}$/.test(phone)) {
          this.model.eSignature.phone = `+421${phone.slice(1)}`;
        } else if (/^[0-9]{4}[0-9]{3}[0-9]{3}$/.test(phone)) {
          this.model.eSignature.phone = `+421${phone.slice(1)}`;
        } else {
          this.model.eSignature.phone = phone.replace(/\s+/g, '');
        }
      }
    },
    async sendSMS() {
      try {
        if (!this.errors.length) {
          this.loaderType = this.enums.LoaderEnum.WAITING;
          this.processPhone(this.model.eSignature.phone);
          const request = {
            uuid: this.model.saveResponse[0].uuid,
            phone: this.model.eSignature.phone.split(' ').join(''),
            signingType: 'SMS',
          };
          const { data } = await this.$axios.post(`${process.env.VUE_APP_API_CONTEXT}/japi/IUzpApi/prepareTransaction`, [request]);
          this.model.prepareTransactionData = data;
          this.$store.commit('SET_E_SIGNATURE_ATTEMPTS', this.$store.state.eSignatureAttempts + 1);
          this.$store.commit('SET_E_TRANSACTION_CREATED', true);
          this.$router.maxStep = 22;
          this.$router.push({ name: 'SmsThankYouPage', query: this.$route.query, params: { model: this.model } });
        }
      } catch (e) {
        try {
          await this.$axios.post(`${process.env.VUE_APP_API_CONTEXT}/japi/IUzpApi/handleUnsignedTransaction`, [this.model.saveResponse[0].uuid]);
          // eslint-disable-next-line no-empty
        } catch (e2) { }
        this.$router.maxStep = 22;
        this.$router.push({ name: 'ThankYouFail', query: this.$route.query, params: { uuid: this.model.saveResponse.uuid } });
      }
    },
    repeatSms() {
      if (this.$store.state.eTransactionCreated && this.model.saveResponse.uuid) {
        this.$axios
          .post(`${process.env.VUE_APP_API_CONTEXT}/japi/IUzpApi/clearTransaction`, [this.model.saveResponse.uuid])
          .then(() => { this.$store.commit('SET_E_TRANSACTION_CREATED', false); });
      }

      this.loaderType = null;
      this.alertVisible = true;

      // this.$gtm.dataLayer().push({
      //   eventCategory: 'zp - esign',
      //   eventAction: 'chybove hlasenie',
      //   eventLabel: 'Skontrolujte správnosť zadaného telefónneho čísla a '
      //     + 'kliknite na tlačidlo Odoslať SMS pre opätovné zaslanie SMS.',
      //   eventValue: undefined,
      //   eventNonInteraction: true,
      //   event: 'eventPush',
      // });

      if (this.$store.state.eSignatureAttempts === 3) {
        this.$router.maxStep = 22;
        this.$router.push({ name: 'ESignatureThankYou', query: this.$route.query, params: { uuid: this.model.saveResponse.uuid } });
      }
    },
  },
  mounted() {
    this.processPhone(this.model.insurer.phone);
  },
};
</script>
